import { useCreation, useRequest } from 'ahooks'
import dayjs from 'dayjs'
import { isNil } from 'lodash'

import { AuctionForm } from '@eastcoal/api/trade/interface'
import { queryAuctionPlanApi } from '@eastcoal/api/trade/plan/queryAuctionPlan'

import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { formatDateTime } from '@eastcoal/common/utils/date'
import { pick } from '@eastcoal/common/utils/object'

export const useCopyPlan = (initialValues: Partial<AuctionForm>) => {
  const { planId } = useUrlParams()

  const { data, loading, error, refreshAsync } = useRequest(
    () => queryAuctionPlanApi({ id: planId }),
    {
      manual: false,
      ready: !isNil(planId),
      refreshDeps: [planId]
    }
  )

  return {
    error,
    loading,
    refreshAsync,
    data: useCreation(
      () =>
        data
          ? {
              ...initialValues,
              ...pick(data, [
                'memberId',
                'memberName',
                'kindId',
                'kindCode',
                'kindName',
                'productName',
                'taxRate',
                'splitCount',
                'wholeSale',
                'requireCertification',
                'certificationName',
                'quantity',
                'depositMethod',
                'depositValue',
                'allowDelay',
                'delayTotalCount',
                'allowStartPrice',
                'startPrice',
                'storagePlaceId',
                'storagePlaceCode',
                'storagePlaceName',
                'depositMethod',
                'minAddPrice',
                'maxAddPrice',
                'pricingMethodId',
                'pricingMethodName',
                'calcStrategy',
                'quantityUnit',
                'priceUnit'
              ]),
              startTime: formatDateTime(dayjs(`${data.auctionDate} 00:00`)),
              planId
            }
          : initialValues,
      [data, initialValues]
    )
  }
}
